import { css } from '@emotion/css'
import AiCreativeIcon from 'images/ai-creative.svg'

const container = css`
  display: flex;
  background-color: #faf9ff;
  border: 1px solid #e0dceb;
  border-radius: 4px;
  padding: 10px;
  gap: 10px;
  align-items: center;
  width: 100%;
  cursor: pointer;
  text-align: left;
  transition: 0.3s;

  &:hover {
    filter: brightness(0.95);
  }
`

const title = css`
  font-weight: 700;
  font-size: 12px;
  color: #2e196b;
  margin: 0;
`

const description = css`
  font-size: 12px;
  color: #2e196b66;
  margin: 0;
`

export const EnableAiClassifications = () => (
  <button css={container}>
    <AiCreativeIcon style={{ width: 26, height: 22, color: '#7F52FF' }} />
    <div>
      <p css={title}>Enable AI Content Comprehension</p>
      <p css={description}>Powered by Claravine AI</p>
    </div>
  </button>
)
